<template>
  <v-card
    :outlined="border"
    :elevation="border ? 2 : 0"
  >
    <v-card-title v-if="label">{{ label }}</v-card-title>
    <v-row>
      <v-col cols="12">
        <v-tabs
          v-model="mode"
          fixed-tabs
          background-color="transparent"
          color="secondary"
          slider-color="secondary"
        >
          <v-tab>
            <v-icon class="mr-2">mdi-image-edit-outline</v-icon>
            designer
          </v-tab>
          <v-tab>
            <v-icon class="mr-2">mdi-code-tags</v-icon>
            code
          </v-tab>
        </v-tabs>
      </v-col>
    </v-row>
    <div
      v-if="mode === 0"
      :class="data_format === 'A4' ? '' : 'd-flex flex-row mb-6'"
    >
      <div style="float: left">
        <div
          ref="html_designer_htmlContainer"
          :style="{
            position: 'relative',
            outline: 'thin solid black',
            width: this.canvasX + 'px',
            height: this.canvasY + 'px',
            margin: '0px !important',
            padding: '0px !important'
          }"
        >
          <div
            :style="containerStyle"
            :canvasX="canvasXcss"
            :canvasY="canvasYcss"
            :format="data_format"
            :orientation="data_orientation"
            :jsonProps="encode({ type: 'background' })"
            v-if="template.elements"
            class="drop-zone"
            ref="html_designer_dropZone"
            @drop="onDrop($event)"
            @dragover.prevent
            @dragenter.prevent
          >
            <interact
              v-for="item in template.elements"
              :jsonProps="encode(item)"
              :key="item.id"
              :id="item.id"
              draggable
              resizable
              :dragOption="dragOption"
              :resizeOption="resizeOption"
              v-on:click.native="selected = item"
              :class="'resize-drag resize-drag-' + item.type"
              :style="elementStyle(item)"
              @dragmove="dragMove"
              @dragend="emitChange = true"
              @resizemove="resizemove"
              @resizeend="emitChange = true"
              v-html="
                item.type === 'image'
                  ? ''
                  : item.type === 'editable_text'
                  ? item.value
                  : '{{' + item.value + '}}'
              "
            >
            </interact>
          </div>
        </div>
      </div>

      <div style="float: right; padding: 20px; width: 100%">
        <v-row v-if="emitChange">
          <v-col cols="6">
            <v-btn
              @click="emitModifiche"
              color="success"
              class="mr-2"
              style="width: 100%"
            >
              <v-icon
                left
                color="white"
              >mdi-floppy</v-icon>
              Salva modifiche
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn
              @click="annullaModifiche(value)"
              color="warning"
              class="mr-2"
              style="width: 100%"
            >
              <v-icon
                left
                color="white"
              >mdi-undo</v-icon>
              Annulla modifiche
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="editableFormat">
          <v-col cols="6">
            <v-select
              v-model="data_format"
              :items="['A6', 'A5', 'A4']"
              label="Formato"
            ></v-select>
          </v-col>
          <v-col cols="6">
            <v-select
              v-if="editableFormat"
              v-model="data_orientation"
              :items="['landscape', 'portrait']"
              label="Orientamento"
            ></v-select>
          </v-col>
        </v-row>
        <v-simple-table v-if="selected">
          <template v-slot:default>
            <tbody>
              <tr>
                <td colspan="4">
                  <v-btn
                    @click="deleteItem"
                    color="error"
                    class="mr-2"
                  >
                    <v-icon
                      left
                      color="white"
                    >mdi-trash-can</v-icon>
                    Rimuovi
                  </v-btn>
                  <v-btn
                    color="green darken-1"
                    icon
                    @click="selected = null"
                    style="float: right"
                  >
                    <v-icon size="32">mdi-close</v-icon>
                  </v-btn>
                </td>
              </tr>
              <tr>
                <td>Tipo</td>
                <td>{{ selected.type }}</td>

                <td>ID</td>
                <td>{{ selected.id }}</td>
              </tr>
              <tr v-if="selected.type === 'editable_text'">
                <td>Valore</td>
                <td colspan="3">
                  <v-text-field
                    v-model="selected.value"
                    @change="emitChange = true"
                    hide-details="auto"
                  ></v-text-field>
                </td>
              </tr>
              <tr v-else>
                <td>Descrizione</td>
                <td colspan="3">{{ selected.dex }}</td>
              </tr>
              <tr v-if="selected.type === 'text' || selected.type === 'editable_text'">
                <td>Font</td>
                <td>

                  <v-autocomplete
                    v-model="selected.fontFamily"
                    @change="emitChange = true"
                    clearable
                    :items="listFont"
                    item-value="value"
                    item-text="text"
                  >
                    <template v-slot:item="data">

                      <span :style="'font-family: '+data.item.value">
                        {{ data.item.text }}</span>

                    </template>
                  </v-autocomplete>
                </td>
                <td>Dimensione</td>
                <td>
                  <v-text-field
                    v-model="selected.fontSize"
                    @change="emitChange = true"
                    hide-details
                    single-line
                    type="number"
                  />
                </td>
              </tr>
              <tr v-if="selected.type === 'text'">
                <td>Allineamento</td>
                <td>
                  <v-select
                    v-model="selected.textAlign"
                    @change="emitChange = true"
                    :items="['', 'left', 'center', 'right', 'justify']"
                    label="Allineamento"
                  ></v-select>
                </td>

                <td>Peso</td>
                <td>
                  <v-select
                    v-model="selected.fontWeight"
                    @change="emitChange = true"
                    :items="['', 'lighter', 'normal', 'bold']"
                    label="Stile"
                  ></v-select>
                </td>
              </tr>

            </tbody>
          </template>
        </v-simple-table>
        <v-row v-else>
          <v-col cols="6">
            <v-btn
              @click="$refs.inputUpload.click()"
              color="primary"
              class="mr-2"
              style="width: 100%"
            >
              <v-icon
                left
                color="white"
              >mdi-upload</v-icon>
              Carica sfondo
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn
              @click="addText"
              color="primary"
              class="mr-2"
              style="width: 100%"
            >
              <v-icon
                left
                color="white"
              >mdi-lead-pencil</v-icon>
              Aggiungi testo
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn
              @click="clearSfondo"
              color="warning"
              class="mr-2"
              style="width: 100%"
            >
              <v-icon
                left
                color="white"
              >mdi-trash-can</v-icon>
              Cancella sfondo
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn
              @click="clearAll"
              color="error"
              class="mr-2"
              style="width: 100%"
            >
              <v-icon
                left
                color="white"
              >mdi-trash-can</v-icon>
              Cancella tutto
            </v-btn>
          </v-col>
        </v-row>
        <div
          v-for="item in selectableFieldComp"
          :jsonProps="encode(item)"
          :key="item.id"
          :id="item.id"
          draggable
          class="resize-drag movable-drag"
          @dragstart="startDrag($event, item)"
          v-html="'<b>{{' + item.value + '}}</b><br/>' + item.dex"
        ></div>
      </div>
    </div>

    <v-row v-if="mode === 1">
      <v-col cols="12">
        <my-html-editor v-model="rawHTML" />
      </v-col>
    </v-row>
    <input
      v-show="false"
      accept="image/*"
      ref="inputUpload"
      type="file"
      @click="resetFileUploader"
      @change="onFileChange"
    />
  </v-card>
</template>

<script>
import interact from "interactjs";
import VComponent from "./VComponent.vue";
import MyHtmlEditor from "@/components/base/MyHtmlEditor.vue";

export default {
  components: { VComponent, MyHtmlEditor },
  name: "html-designer",
  props: {
    componentKey: {
      type: String,
      default: "html_designer",
    },
    value: null,
    label: null,
    border: true,
    editableFormat: {
      type: Boolean,
      default: false,
    },
    selectableField: {
      type: Array,
      default: function () {
        return new Array();
      },
    },
    format: {
      type: String,
      default: null,
    },
    orientation: {
      type: String,
      default: null,
    },
    position: { type: String, default: "absolute" },
    maxSize: {
      type: Number,
      default: 20,
    },
  },
  data: () => ({
    canvasX: 0,
    canvasY: 0,
    data_format: null,
    data_orientation: null,
    files: null,
    emitChange: false,
    mode: 0,
    selected: null,
    rawHTML: "",
    selectableFieldFixed: [],
    template: { background: null, elements: [], loaded: false },
    resizeOption: {
      edges: { left: false, right: true, bottom: true, top: false },
    },
    dragOption: {
      modifiers: [
        interact.modifiers.restrictRect({
          restriction: "parent",
        }),
      ],
    },
  }),
  beforeDestroy() {
    this.template = { background: null, elements: [], loaded: false };
  },
  mounted() {
    this.data_format = this.format ? this.format : "A5";
    this.data_orientation = this.orientation ? this.orientation : "landscape";
    this.calcolateCanvas();
    this.parseTemplate(this.value);
    this.selectableFieldFixed = [];
    let x = 0;
    for (let el of this.selectableField) {
      el.id = el.value;
      el.x = 0;
      el.y = 10;
      this.selectableFieldFixed.push(el);
    }
  },
  watch: {
    selectableField: {
      handler: function (newSelected) {
        this.selectableFieldFixed = [];
        for (let el of this.selectableField) {
          el.id = el.value;
          el.x = 0;
          el.y = 10;
          this.selectableFieldFixed.push(el);
        }
      },
      deep: true,
    },
    emitChange: function (newVal, oldVal) {
      this.$emit("change2save", newVal);
    },
    format: function (newVal, oldVal) {
      this.data_format = this.format ? this.format : newVal;
    },
    orientation: function (newVal, oldVal) {
      this.data_orientation = this.orientation ? this.orientation : newVal;
    },
    data_format: function (newVal, oldVal) {
      this.calcolateCanvas();
    },
    data_orientation: function (newVal, oldVal) {
      this.calcolateCanvas();
    },
    value: function (newVal, oldVal) {
      this.parseTemplate(newVal);
    },
    rawHTML: {
      handler: function (newSelected) {
        if (newSelected) this.$emit("input", newSelected);
      },
      deep: true,
    },
  },
  computed: {
    selectableFieldComp() {
      let draggedId = this.template.elements.map((el) => {
        return el.id;
      });
      return this.selectableFieldFixed.filter((el) => {
        return !draggedId.includes(el.id);
      });
    },
    listFont() {
      return window.systemData.supportedFonts.map((el) => {
        return { value: el, text: el };
      });
    },
    canvasYcss() {
      return this.canvasY && this.canvasY > 0 ? this.canvasY + "px" : "100%";
    },
    canvasXcss() {
      return this.canvasX && this.canvasX > 0 ? this.canvasX + "px" : "100%";
    },
    containerStyle() {
      let style = {
        height: this.canvasYcss,
        width: this.canvasXcss,
        margin: "0px !important",
        padding: "0px !important",
      };
      if (this.template && this.template.background) {
        style.backgroundImage = this.template.background;
        style.backgroundSize = "cover";
      }
      return style;
    },
  },

  updated() {
    // this.$nextTick(() => {
    //   if (
    //     this.emitChange === true &&
    //     this.$refs.html_designer_htmlContainer &&
    //     this.$refs.html_designer_htmlContainer.innerHTML
    //   ) {
    //     let html = "";
    //     if (
    //       this.elements &&
    //       (this.elements.length > 0 || this.elements.background)
    //     )
    //       html =
    //         "<style>body {margin: 0px !important;}</style>" +
    //         this.$refs.html_designer_htmlContainer.innerHTML;
    //     this.$emit("input", html);
    //     this.emitChange = false;
    //   }
    //   //assuming you've added a "canvas" ref
    // });
  },
  methods: {
    annullaModifiche(value) {
      this.parseTemplate(value);
    },
    emitModifiche() {
      let html =
        "<style>body {margin: 0px !important;}</style>" +
        this.$refs.html_designer_htmlContainer.innerHTML;
      this.$emit("input", html);
      this.emitChange = false;
    },
    calcolateCanvas() {
      if (this.data_format === "A7") {
        this.canvasX = this.data_orientation === "landscape" ? 397 : 280;
        this.canvasY = this.data_orientation === "landscape" ? 280 : 397;
      }
      if (this.data_format === "A6") {
        this.canvasX = this.data_orientation === "landscape" ? 559 : 397;
        this.canvasY = this.data_orientation === "landscape" ? 397 : 559;
      }
      if (this.data_format === "A5") {
        this.canvasX = this.data_orientation === "landscape" ? 794 : 559;
        this.canvasY = this.data_orientation === "landscape" ? 559 : 794;
      }
      if (this.data_format === "A4") {
        this.canvasX = this.data_orientation === "landscape" ? 1123 : 794;
        this.canvasY = this.data_orientation === "landscape" ? 794 : 1123;
      }
      // rimuove elementi che escono dal canvas
      let _ = this;
      this.template.elements = this.template.elements.filter((el) => {
        return el.x + el.w <= _.canvasX && el.y + el.h <= _.canvasY;
      });
    },
    encode(item) {
      return window.btoa(JSON.stringify(item));
    },
    decode(string) {
      return JSON.parse(window.atob(string));
    },
    addText() {
      let id = this.template.elements.length + 1;
      this.template.elements.push({
        type: "editable_text",
        id: "text_" + id,
        value: "text_" + id,
        dex: "text",
        h: 50,
        w: 200,
        x: 0,
        y: 0,
      });
      this.emitChange = true;
    },
    deleteItem() {
      let _ = this;
      this.template.elements = this.template.elements.filter((el) => {
        return el.id !== _.selected.id;
      });
      this.emitChange = true;
      _.selected = null;
    },
    startDrag(evt, item) {
      evt.dataTransfer.dropEffect = "move";
      evt.dataTransfer.effectAllowed = "move";
      evt.dataTransfer.setData("itemID", item.id);
      let leftOrig = evt.srcElement.getBoundingClientRect().left;
      let topOrig = evt.srcElement.getBoundingClientRect().top;
      let offsetX = evt.clientX - leftOrig;
      let offsetY = evt.clientY - topOrig;
      evt.dataTransfer.setData("offsetX", offsetX);
      evt.dataTransfer.setData("offsetY", offsetY);
    },
    onDrop(evt) {
      let item = evt.dataTransfer.getData("itemID");
      let leftDestination =
        this.$refs.html_designer_dropZone.getBoundingClientRect().left;
      let topDestination =
        this.$refs.html_designer_dropZone.getBoundingClientRect().top;

      let offsetX = evt.dataTransfer.getData("offsetX");
      let offsetY = evt.dataTransfer.getData("offsetY");
      let currentItem = this.selectableFieldFixed.find((el) => {
        return el.id === item;
      });
      this.template.elements.push({
        type: currentItem.type,
        value: currentItem.value,
        id: currentItem.id,
        dex: currentItem.dex,
        h: 50,
        w: 200,
        x: evt.clientX - leftDestination - offsetX,
        y: evt.clientY - topDestination - offsetY,
      });
      this.emitChange = true;
    },
    resetFileUploader() {
      this.$refs.inputUpload.value = null;
    },
    onFileChange(event) {
      let _ = this;
      if (!event.target.files) return;
      else {
        _.createImage(event.target.files[0]);
        event.target.files = null;
      }
    },
    createImage(file) {
      let _ = this;
      let reader = new FileReader();
      //_.template.background = null;
      reader.onload = (e) => {
        _.template.background = "url('" + e.target.result + "')";
        _.emitChange = true;
      };
      if (file) reader.readAsDataURL(file);
    },
    clearAll() {
      this.template = { background: null, elements: [], loaded: false };
      this.emitChange = true;
    },
    clearSfondo() {
      this.template.background = null;
      this.emitChange = true;
    },
    parseTemplate(html) {
      let _ = this;
      _.rawHTML = html;
      _.selected = null;
      let template = { background: null, elements: [], loaded: false };

      if (!html || html === "") {
        template.loaded = true;
        _.emitChange = false;
        _.template = template;
        return;
      }
      try {
        html = html.replace(
          "<style>body {margin: 0px !important;}</style>",
          ""
        );
        let parsedHtml = new DOMParser().parseFromString(html, "text/html");
        _.mode = 1;
        for (let element of parsedHtml.all) {
          if (element.className === "drop-zone") {
            if (!_.orientation && element.attributes.orientation)
              _.data_orientation = element.attributes.orientation.value;
            if (!_.format && element.attributes.format)
              _.data_format = element.attributes.format.value;
          }
          if (element.attributes.jsonprops) {
            _.mode = 0;
            let props = _.decode(element.attributes.jsonprops.nodeValue);
            if (props.type === "background") {
              template.background = element.style["background-image"];
            } else {
              template.elements.push(props);
            }
          }
        }
        template.loaded = true;
        _.template = template;
      } catch (e) {
        _.template = template;
      }
      _.emitChange = false;
    },
    decodeHtml(text) {
      let entities = {
        amp: "&",
        apos: "'",
        "#x27": "'",
        "#x2F": "/",
        "#39": "'",
        "#47": "/",
        lt: "<",
        gt: ">",
        nbsp: " ",
        quot: '"',
      };
      return text.replace(/&([^;]+);/gm, function (match, entity) {
        return entities[entity] || match;
      });
    },
    elementStyle(item) {
      let style = {
        position: this.position,
        height: `${item.h}px`,
        width: `${item.w}px`,
        top: `${item.y}px`,
        left: `${item.x}px`,
        //transform: `translate(${item.x}px, ${item.y}px)`,
      };

      if (item.type === "image") {
        style.backgroundImage = `url({{${item.value}}})`;
        style.backgroundSize = "contain";
        style.backgroundRepeat = "no-repeat";
      } else {
        style.backgroundColor = "transparent";
        style.lineHeight = "100%";
        if (item.textAlign) style["text-align"] = item.textAlign;
        if (item.fontSize) style["font-size"] = item.fontSize + "px";
        if (item.fontWeight) style["font-weight"] = item.fontWeight;
        if (item.fontFamily) style["font-family"] = item.fontFamily;
      }
      return style;
    },
    elementStyleToAdd() {
      let style = {
        position: `relative`,
        height: `20px`,
        width: `"100%"`,
        marginTop: "10px",
        backgroundColor: this.$vuetify.theme.currentTheme.secondary,
        border: "2px solid " + this.$vuetify.theme.currentTheme.primary,
        lineHeight: "100%",
      };
      return style;
    },
    dragMoveToAdd(event) {
      let id = event.currentTarget.id;
      for (let element of this.selectableFieldFixed) {
        if (element.id === id) {
          element.x = element.x + event.dx;
          element.y = element.y + event.dy;
        }
      }
    },
    dragMove(event) {
      let id = event.currentTarget.id;
      for (let element of this.template.elements) {
        if (element.id === id) {
          element.x += event.dx;
          element.y += event.dy;
        }
      }
    },
    resizemove(event) {
      let id = event.currentTarget.id;
      let left = this.$refs.html_designer_dropZone.getBoundingClientRect().left;
      let right =
        this.$refs.html_designer_dropZone.getBoundingClientRect().right;
      let top = this.$refs.html_designer_dropZone.getBoundingClientRect().top;
      let bottom =
        this.$refs.html_designer_dropZone.getBoundingClientRect().bottom;

      for (let element of this.template.elements) {
        if (element.id === id) {
          element.w = event.rect.width;
          element.h = event.rect.height;
          if (element.h < 10) element.h = 10;

          element.x += event.deltaRect.left;
          element.y += event.deltaRect.top;

          let maxWidth = right - left - element.x;
          let maxHeight = bottom - top - element.y;

          if (element.h > maxHeight) element.h = maxHeight;
          if (element.w > maxWidth) element.w = maxWidth;
        }
      }
    },
    moveToAdd(event) {
      let id = event.currentTarget.id;
      for (let element of this.selectableFieldFixed) {
        if (element.id === id) {
          element.x += event.deltaRect.left;
          element.y += event.deltaRect.top;
        }
      }
    },
  },
};
</script>

<style scoped>
.v-tab {
  max-width: none;
}
.movable-drag {
  margin: 10px;
  width: 200px;
  height: 50px;
  line-height: 25px;
  text-align: center;
  float: left;
}

.resize-drag {
  box-sizing: border-box;
  /* To prevent interact.js warnings */
  user-select: none;
  -ms-touch-action: none;
  touch-action: none;
  border: 1px solid black !important;
  background-color: white !important;
}
.resize-drag-image {
  color: transparent !important;
  background-image: none !important;
  background-color: white !important;
  background: white !important;
  background-size: 10px 10px !important;
  background-image: repeating-linear-gradient(
    45deg,
    rgba(0, 0, 0, 0.54) 0,
    rgba(0, 0, 0, 0.54) 1px,
    white 0,
    white 50%
  ) !important;
}
</style>